let api = 'https://dev-api.pillpez.com/'

if (process.env.REACT_APP_API_URL) {
    api = process.env.REACT_APP_API_URL
}
if (process.env.PILLPEZ_API_URL) {
    api = process.env.PILLPEZ_API_URL
}
export const API_URL = api;
